import React from 'react';
import { Popover, Whisper, Checkbox, Dropdown, IconButton, Table, CellProps } from 'rsuite';
import MoreIcon from '@rsuite/icons/legacy/More';
import AvatarIcon from '@rsuite/icons/legacy/Avatar';
import { FaUser } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';


const { Cell } = Table;

export const NameCell = ({ rowData, dataKey, ...props }: CellProps) => {
  const { t } = useTranslation();

  const speaker = (
    <Popover title={rowData.firstname + ' ' + rowData.lastname}>
      <p>
        <b>{t('Registration Number:')}</b> {rowData.registrationNumber}
      </p>
      <p>
        <b>{t('Grade:')}</b> {rowData.grade?.grade_name}
      </p>
      <p>
        <b>{t('Team:')}</b> {rowData.serviceLine?.serviceLine}
      </p>
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper placement="top" speaker={speaker}>
        <a>{rowData.firstname + ' ' + rowData.lastname}</a>
      </Whisper>
    </Cell>
  );
};

export const ImageCell = ({ rowData, dataKey, ...props }: CellProps) => (
  <Cell {...props} style={{ padding: 0 }}>
    <div
      style={{
        width: 40,
        height: 40,
        background: '#f5f5f5',
        borderRadius: 6,
        marginTop: 2,
        overflow: 'hidden',
        // display: 'inline-block'
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {rowData[dataKey!] && rowData[dataKey!] != undefined ? (
        <img src={process.env.REACT_APP_IMAGE_URL + rowData[dataKey!]} width="40" />
      ) : (
        <FaUser style={{ fontSize: 24, color: '#666' }} />
      )}
    </div>
  </Cell>
);

export const CheckCell = ({
  rowData,
  onChange,
  checkedKeys,
  dataKey,
  ...props
}: CellProps & {
  checkedKeys: number[];
  onChange: (value: any, checked: boolean) => void;
}) => (
  <Cell {...props} style={{ padding: 0 }}>
    <div style={{ lineHeight: '46px' }}>
      <Checkbox
        value={rowData[dataKey!]}
        inline
        onChange={onChange}
        checked={checkedKeys?.some(item => item === rowData[dataKey!])}
      />
    </div>
  </Cell>
);

const renderMenu = ({ onClose, left, top, className }: any, ref) => {
  const handleSelect = eventKey => {
    onClose();
    console.log(eventKey);
  };
  return (
    <Popover ref={ref} className={className} style={{ left, top }} full>
      <Dropdown.Menu onSelect={handleSelect}>
        <Dropdown.Item eventKey={1}>{t('Edit')}</Dropdown.Item>
        <Dropdown.Item eventKey={5}>{t('Block')}</Dropdown.Item>
      </Dropdown.Menu>
    </Popover>
  );
};

export const ActionCell = props => {
  return (
    <Cell {...props} className="link-group">
      {/* <Whisper placement="autoVerticalEnd" trigger="click" speaker={renderMenu}>
        <IconButton appearance="subtle" icon={<MoreIcon />} />
      </Whisper> */}
      <IconButton appearance="subtle" icon={<MoreIcon />} />
    </Cell>
  );
};
